import { ChainId, Token } from 'sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import { CHAIN_ID } from './networks'
import { SerializedToken } from './types'

const { MAINNET, TESTNET, PG_TEST } = ChainId

interface TokenList {
  [symbol: string]: Token
}

const defineTokens = <T extends TokenList>(t: T) => t

export const mainnetTokens = defineTokens({
  usdt: new Token(
    MAINNET,
    '0x15C2Da2752bEECDd4893742ee4FEd54F4E3209AA',
    6,
    'TUSDT',
    'token',
    'https://www.binance.com/',
  ),
  wctc: new Token(
    MAINNET,
    '0x9F363dDBc7cee2abBCF661fFa2F1C17c6e0b92bD',
    18,
    'WCTC',
    'Wrapped CTC',
    'https://www.binance.com/',
  ),
  usdc: new Token(
    MAINNET,
    '0x2fF5788Aae52d316bEF6307D8D0C0b959BdADe5A',
    6,
    'TUSDC',
    'token',
    'https://www.binance.com/',
  ),
  busd: new Token(
    MAINNET,
    '0x0000000000000000000000000000000000000001',   // 计算价格要用-useBUSDPrice
    18,
    'BUSD',
    'token',
    'https://www.binance.com/',
  ),
  cake: new Token(
    MAINNET,
    '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    18,
    'CAKE',
    'PancakeSwap Token',
    'https://pancakeswap.finance/',
  ),
} as const)

export const testnetTokens = defineTokens({
  usdt: new Token(
    TESTNET,
    '0x3d1a4F0B10bcF763cC0dbd632fa5533E233Ea8fd',
    18,
    'USDT',
    'token',
    'https://www.binance.com/',
  ),
  wctc: new Token(
    TESTNET,
    '0xcbE58a2851AE329c3d7f6F24dd4b63a6709de2AB',
    18,
    'WCTC',
    'Wrapped CTC',
    'https://www.binance.com/',
  ),
  wee: new Token(
    TESTNET,
    '0xe4c4ba99dC964B708371852ba45534f9b9a99ff2',
    18,
    'WEE',
    'token',
    'https://www.binance.com/',
  ),
  busd: new Token(
    TESTNET,
    '0x0000000000000000000000000000000000000001',   // 计算价格要用-useBUSDPrice
    18,
    'BUSD',
    'token',
    'https://www.binance.com/',
  ),
  cake: new Token(
    TESTNET,
    '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    18,
    'CAKE',
    'PancakeSwap Token',
    'https://pancakeswap.finance/',
  ),
} as const)



const tokens = () => {
  const chainId = CHAIN_ID

  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  // if (chainId === '12302') return pgTestTokens
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    // return testnetTokens
    return Object.keys(mainnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    }, {} as typeof testnetTokens & typeof mainnetTokens)
  } else {
    return mainnetTokens
  }
}

const unserializedTokens = tokens()

type SerializedTokenList = Record<keyof typeof unserializedTokens, SerializedToken>

export const serializeTokens = () => {
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {} as SerializedTokenList)

  return serializedTokens
}

export default unserializedTokens
